"use client"
import { useState, useEffect } from "react";
import { CannedResponse, DefaultCannedResponses } from "../types";

export function useCannedResponses() {
  const [cannedResponses] = useState<CannedResponse[]>(DefaultCannedResponses);
  const [customResponses, setCustomResponses] = useState<CannedResponse[]>([]);
  const [customCategories, setCustomCategories] = useState<string[]>([]);
  const [showCannedResponsesSheet, setShowCannedResponsesSheet] = useState(false);

  // Load custom responses from localStorage
  useEffect(() => {
    const storedCustomResponses = localStorage.getItem("custom_canned_responses");
    const storedCategories = localStorage.getItem("custom_response_categories");
    
    if (storedCustomResponses) {
      try {
        setCustomResponses(JSON.parse(storedCustomResponses));
      } catch (e) {
        console.error("Error parsing stored custom responses:", e);
      }
    }
    
    if (storedCategories) {
      try {
        setCustomCategories(JSON.parse(storedCategories));
      } catch (e) {
        console.error("Error parsing stored categories:", e);
      }
    }
  }, []);

  // Save custom responses to localStorage when they change
  useEffect(() => {
    localStorage.setItem("custom_canned_responses", JSON.stringify(customResponses));
  }, [customResponses]);
  
  // Save custom categories to localStorage when they change
  useEffect(() => {
    localStorage.setItem("custom_response_categories", JSON.stringify(customCategories));
  }, [customCategories]);

  return {
    cannedResponses,
    customResponses,
    setCustomResponses,
    customCategories,
    setCustomCategories,
    showCannedResponsesSheet,
    setShowCannedResponsesSheet
  };
}
